import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { routeMappings } from '../../constants';
import { SessionStore } from '../../constants/sessionStore';

/** Component for implementing scroll to top as history route changes*/
const ScrollToTop = (): null => {
  const history = useHistory();

  useEffect(() => {
    const unlisten = history.listen(({ pathname }) => {
      const isTaskInitialized = sessionStorage.getItem(SessionStore.isTaskInitialized);
      const onTaskListPage = pathname.includes(routeMappings['TASKLIST']);
      const onVideoTaskPage = window.location.hash.includes(routeMappings['EXPVIDEOTASK']);

      if (!(onTaskListPage && isTaskInitialized) && !onVideoTaskPage) {
        window.scrollTo(0, 0);
      }
    });
    return (): void => {
      unlisten();
    };
  }, [history]);

  return null;
};

export default ScrollToTop;
